import { render, staticRenderFns } from "./jobs.vue?vue&type=template&id=c1e20704&scoped=true&"
import script from "./jobs.vue?vue&type=script&lang=js&"
export * from "./jobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e20704",
  null
  
)

export default component.exports